import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetCurrentCourses = ({ selectedStudentId } = {}) => {
    const {
        data: courses,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["currentCourses", selectedStudentId],
        enabled: Boolean(selectedStudentId),
        queryFn: () =>
            axiosManager
                .get$(
                    `student/${encodeURIComponent(selectedStudentId)}/courses/current`,
                )
                .then((res) => res.data),
    });

    return { courses, error, isLoading };
};

export default useGetCurrentCourses;
